
define(
	'StoreLocator.Shopping'
	, [
		'StoreLocator.Tooltip.View.Extension',
		'StoreLocator.Search.View.Extension',
		'StoreLocator.Results.View.Extension',
		'Location.Collection.Extension',
		'StoreLocator.Map.View.Extension',
		'StoreLocator.Details.View.Extension'
	]
	, function (
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				
			}
		};
	});
